module.exports = function() {
  return new Worker("/WebWorldWind-X/" + "af95d0291b447e9143b7.worker.js");
};